module.exports = __webpack_public_path__ + "static/giant-fights-e005d4c6205a1778e5e8ca4d08d46ea5.jpg";